import React from "react";

interface PolicyProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
}

const Policy: React.FC<PolicyProps> = ({
  fill = "#3C3C3C",
  stroke = "none",
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.57324 16.5V9.5H5.57324V16.5H3.57324ZM9.57324 16.5V9.5H11.5732V16.5H9.57324ZM0.573242 20.5V18.5H20.5732V20.5H0.573242ZM15.5732 16.5V9.5H17.5732V16.5H15.5732ZM0.573242 7.5V5.5L10.5732 0.5L20.5732 5.5V7.5H0.573242ZM5.02324 5.5H16.1232L10.5732 2.75L5.02324 5.5Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export default Policy;
